
export type AiPlausibilityRiskLevel = typeof AiPlausibilityRiskLevel[keyof typeof AiPlausibilityRiskLevel];


export const AiPlausibilityRiskLevel = {
  Unknown: 'Unknown',
  Info: 'Info',
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
} as const;
